"use client";
import {
  createStoreContext
} from "./3ORBWXWF.js";

// src/collection/collection-context.tsx
var ctx = createStoreContext();
var useCollectionContext = ctx.useContext;
var useCollectionScopedContext = ctx.useScopedContext;
var useCollectionProviderContext = ctx.useProviderContext;
var CollectionContextProvider = ctx.ContextProvider;
var CollectionScopedContextProvider = ctx.ScopedContextProvider;

export {
  useCollectionContext,
  useCollectionScopedContext,
  useCollectionProviderContext,
  CollectionContextProvider,
  CollectionScopedContextProvider
};
